'use client';

import { useEffect } from 'react';
import { identify, optIn } from '@upms/analytics';
import { useAuthContext } from '@/components/AuthContext';
import { processError } from '@/lib/processError';

export function AnalyticsUserSync() {
  const { getSession } = useAuthContext();

  // Every session starts opted out (see @upms/analytics), so no analytics
  // reaches anonymous visitors. optIn must run first — identify calls made
  // before it are silently ignored.
  useEffect(() => {
    void getSession()
      .then(({ accountId }) => {
        optIn();
        identify(accountId);
      })
      .catch((error) => {
        processError(error, { feature: 'analytics', operation: 'optInAndIdentify' });
      });
  }, [getSession]);

  return null;
}
